import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import PasswordForm from "@components/ResetPasswordForm/PasswordForm";
import EmailForm from "@components/ResetPasswordForm/EmailForm";
import PublicForm from "@components/PublicForm";

const ResetPasswordForm: FC = () => {
  const { t } = useTranslation();
  const email = useSelector((state: RootState) => state.resetPassword.email);

  return (
    <PublicForm
      title={t("resetPassword.title")}
      subtitle={t("resetPassword.subtitle")}
    >
      {email ? <PasswordForm /> : <EmailForm />}
    </PublicForm>
  );
};

export default ResetPasswordForm;
